import { render, staticRenderFns } from "./AddVehicle.vue?vue&type=template&id=3b1c30c6"
import script from "./AddVehicle.vue?vue&type=script&lang=js"
export * from "./AddVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports